import { API_URL } from "constant";
import { useNetwork } from "hooks";
import { FC, useCallback, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { LoginPhoneNumberState } from "states";

import style from "./waiting.module.sass";

interface IWaiting {
  onSuccess: Function;
  onFailed: Function;
  locationInfo: any;
  ipAddress: string;
}

let isEventCalled = false;

export const Waiting: FC<IWaiting> = ({
  onSuccess,
  onFailed,
  locationInfo,
  ipAddress,
}) => {
  const loginNumber = useRecoilValue(LoginPhoneNumberState);
  const [checkStatus, setCheckStatus] = useState<boolean>(false);
  const { post } = useNetwork();
  const { post: loginStatus } = useNetwork();

  const sendConfirmation = useCallback(async () => {
    const payload = {
      channelName: "users",
      data: {
        phone: loginNumber?.phone,
        countryCode: loginNumber?.countryCode,
      },
      eventName: `connect:${loginNumber?.phone}`,
    };

    if (loginNumber?.phone?.length > 0) {
      post(API_URL.WaitingLogin, payload)
        .then((resp) => {
          if (resp?.success) {
            isEventCalled = true;
          }
        })
        .catch((err) => {});
    }
  }, [loginNumber?.countryCode, loginNumber?.phone, post]);

  useEffect(() => {
    sendConfirmation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginNumber]);

  const getStatus = useCallback(async () => {
    const payload = {
      channelName: "webUser",
      data: {
        phone: loginNumber?.phone,
        countryCode: loginNumber?.countryCode,
      },
      eventName: `permission`,
    };
    loginStatus(API_URL.LoginStatus, payload)
      .then((resp) => {
        const { status } = resp ?? {};
        if (status === "CONNECTED") {
          const payload = {
            success: true,
            location: locationInfo,
            ip: ipAddress,
          };
          onSuccess(payload);
        }
      })
      .catch((err) => onFailed(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginNumber]);
  useEffect(() => {
    if (isEventCalled) {
      getStatus();
    }
    setTimeout(() => {
      setCheckStatus((pre) => !pre);
    }, 5000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkStatus, isEventCalled]);

  return (
    <div className={style.wrapper}>
      <div className={style.inner_wrapper}>
        <div className={style.inner}>
          <img
            src="https://cdnjs.stage.satschel.com/v2/bankinglogin/clock.svg"
            alt="waiting"
            className={style.render_image}
          />
          <div className={style.title}>Waiting for Approval</div>
          <div className={style.sub_title}>
            Open Liquid app and give access to login the liquid exchange app.
          </div>
        </div>
      </div>
    </div>
  );
};
